import { render, staticRenderFns } from "./DialogSelecionarFrentista.vue?vue&type=template&id=0dcd6560"
import script from "./DialogSelecionarFrentista.vue?vue&type=script&lang=js"
export * from "./DialogSelecionarFrentista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports